import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { CommonModule, CurrencyPipe, DecimalPipe, NgFor } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FuseCardComponent } from '@fuse/components/card';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { BannerSectionType01Component } from '../../banner-section/banner_section-type01/banner_section-type01.component';
import { FormsModule } from '@angular/forms';
import { HeadingSectionType01Component } from '../../heading-section/heading_section-type01/heading_section-type01.component';
import { EventEnquireModalComponent } from '../event-enquire-modal/event-enquire-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { EnquirepadelmodalComponent } from '../enquirepadelmodal/enquirepadelmodal.component';

@Component({
    selector: 'app-padel',
    standalone: true,
    imports: [
        MatIconModule,
        DecimalPipe,
        CurrencyPipe,
        MatTooltipModule,
        RouterLink,
        FuseCardComponent,
        BannerSectionType01Component,
        MatSlideToggleModule,
        NgFor, FormsModule, CommonModule, HeadingSectionType01Component
    ],
    templateUrl: './padel.component.html',
    styleUrl: './padel.component.scss'
})
export class PadelComponent implements OnInit {
    PADEL_PACKAGES: any = [
    {
        search: { name: "Padel Tournament" },
        isEvent: true,
        itineraryID: 1,
        category: "Sports",
        date: "2024-03-15T10:00:00",
        tickets: [
            {
                category: "Standard Entry",
                sell: 50,
                currencyCode: "USD",
                description: "General admission ticket",
                imageUrl: "assets/images/events/padel1.jpg",
                stock: 100
            },
            {
                category: "VIP Package",
                sell: 120,
                currencyCode: "USD",
                description: "VIP seating + refreshments",
                imageUrl: "assets/images/events/padel1.jpg",
                stock: 20
            }
        ],
        priceAdvertise: 50,
        currency: "USD",
        supplierName: "Padel Masters",
        supplier: {
            name: "Padel Masters",
            place: "Barcelona",
            contentShort: "Join the biggest padel tournament of the year with top international players",
            contentHighlights: "Competition",
            images: {
                imageUrlBg: "url('assets/images/events/padel1.jpg')",
                rawImageUrl: "assets/images/events/padel1.jpg"
            }
        }
    },
    {
        search: { name: "FIP Padel Tournament" },
        isEvent: true,
        itineraryID: 1,
        category: "Sports",
        date: "2024-08-16T10:00:00", // Assuming the tournament starts on Friday, August 16
        tickets: [
            {
                category: "Friday",
                sell: 50,
                currencyCode: "USD",
                description: "Friday tournament access",
                imageUrl: "assets/images/events/padel1.jpg",
                stock: 100
            },
            {
                category: "Saturday",
                sell: 60,
                currencyCode: "USD",
                description: "Saturday tournament access",
                imageUrl: "assets/images/events/padel1.jpg",
                stock: 100
            },
            {
                category: "Sunday",
                sell: 70,
                currencyCode: "USD",
                description: "Sunday tournament access",
                imageUrl: "assets/images/events/padel1.jpg",
                stock: 100
            },
            {
                category: "Friday & Saturday",
                sell: 100,
                currencyCode: "USD",
                description: "Two-day tournament access (Friday and Saturday)",
                imageUrl: "assets/images/events/padel1.jpg",
                stock: 80
            },
            {
                category: "Friday, Saturday and Sunday",
                sell: 150,
                currencyCode: "USD",
                description: "Full weekend tournament access",
                imageUrl: "assets/images/events/padel1.jpg",
                stock: 50
            },
        ],
        priceAdvertise: 50, // Lowest price ticket
        currency: "USD",
        supplierName: "FIP Padel",
        supplier: {
            name: "FIP Padel",
            place: "Barcelona",
            contentShort: "Join the official FIP Padel Tournament featuring top international players",
            contentHighlights: "Professional Competition",
            images: {
                imageUrlBg: "url('assets/images/events/padel1.jpg')",
                rawImageUrl: "assets/images/events/padel1.jpg"
            }
        }
    },
    {
        search: { name: "Padel Training Camp" },
        isEvent: true,
        itineraryID: 2,
        category: "Training",
        date: "2024-04-05T09:00:00",
        tickets: [
            {
                category: "3-Day Camp",
                sell: 200,
                currencyCode: "USD",
                description: "Intensive training with pros",
                imageUrl: "assets/images/events/padel2.jpg",
                stock: 15
            },
            {
                category: "Weekend Workshop",
                sell: 90,
                currencyCode: "USD",
                description: "Saturday-Sunday training",
                imageUrl: "assets/images/events/padel2.jpg",
                stock: 8
            }
        ],
        priceAdvertise: 200,
        currency: "USD",
        supplierName: "Padel Academy",
        supplier: {
            name: "Padel Academy",
            place: "Madrid",
            contentShort: "Improve your padel skills with professional coaches in our state-of-the-art facilities",
            contentHighlights: "Training",
            images: {
                imageUrlBg: "url('assets/images/events/padel2.jpg')",
                rawImageUrl: "assets/images/events/padel2.jpg"
            }
        }
    },
    {
        search: { name: "Padel Beach Cup" },
        isEvent: true,
        itineraryID: 3,
        category: "Sports",
        date: "2024-05-20T08:00:00",
        tickets: [
            {
                category: "Early Bird",
                sell: 40,
                currencyCode: "USD",
                description: "Limited early registration",
                imageUrl: "assets/images/events/padel3.jpg",
                stock: 5
            },
            {
                category: "Standard",
                sell: 60,
                currencyCode: "USD",
                description: "Regular admission",
                imageUrl: "assets/images/events/padel3.jpg",
                stock: 50
            }
        ],
        priceAdvertise: 40,
        currency: "USD",
        supplierName: "Beach Padel Club",
        supplier: {
            name: "Beach Padel Club",
            place: "Valencia",
            contentShort: "Experience padel on the beach with this unique tournament format",
            contentHighlights: "Beach Competition",
            images: {
                imageUrlBg: "url('assets/images/events/padel3.jpg')",
                rawImageUrl: "assets/images/events/padel3.jpg"
            }
        }
    },
    {
        search: { name: "Corporate Padel Challenge" },
        isEvent: true,
        itineraryID: 4,
        category: "Corporate",
        date: "2024-06-10T18:00:00",
        tickets: [
            {
                category: "Team Entry",
                sell: 300,
                currencyCode: "USD",
                description: "Entry for 4 players",
                imageUrl: "assets/images/events/padel4.jpg",
                stock: 12
            }
        ],
        priceAdvertise: 300,
        currency: "USD",
        supplierName: "Business Padel Network",
        supplier: {
            name: "Business Padel Network",
            place: "Barcelona",
            contentShort: "Networking tournament for corporate teams with after-party included",
            contentHighlights: "Networking",
            images: {
                imageUrlBg: "url('assets/images/events/padel4.jpg')",
                rawImageUrl: "assets/images/events/padel4.jpg"
            }
        }
    },
    {
        search: { name: "Junior Padel Championship" },
        isEvent: true,
        itineraryID: 5,
        category: "Junior",
        date: "2024-07-15T09:00:00",
        tickets: [
            {
                category: "Under 12",
                sell: 25,
                currencyCode: "USD",
                description: "For players under 12 years",
                imageUrl: "assets/images/events/padel5.jpg",
                stock: 30
            },
            {
                category: "Under 16",
                sell: 35,
                currencyCode: "USD",
                description: "For players under 16 years",
                imageUrl: "assets/images/events/padel5.jpg",
                stock: 25
            }
        ],
        priceAdvertise: 25,
        currency: "USD",
        supplierName: "Youth Padel Foundation",
        supplier: {
            name: "Youth Padel Foundation",
            place: "Seville",
            contentShort: "Annual championship for young padel players with professional scouts attending",
            contentHighlights: "Youth Competition",
            images: {
                imageUrlBg: "url('assets/images/events/padel5.jpg')",
                rawImageUrl: "assets/images/events/padel5.jpg"
            }
        }
    },
    {
        search: { name: "Padel Pro-Am Tournament" },
        isEvent: true,
        itineraryID: 6,
        category: "Sports",
        date: "2024-08-12T10:00:00",
        tickets: [
            {
                category: "Spectator",
                sell: 30,
                currencyCode: "USD",
                description: "General admission",
                imageUrl: "assets/images/events/padel6.jpg",
                stock: 200
            },
            {
                category: "Amateur Player",
                sell: 150,
                currencyCode: "USD",
                description: "Entry for amateur players",
                imageUrl: "assets/images/events/padel6.jpg",
                stock: 40
            }
        ],
        priceAdvertise: 30,
        currency: "USD",
        supplierName: "Pro Padel League",
        supplier: {
            name: "Pro Padel League",
            place: "Malaga",
            contentShort: "Play alongside professionals in this unique tournament format",
            contentHighlights: "Pro-Am Event",
            images: {
                imageUrlBg: "url('assets/images/events/padel6.jpg')",
                rawImageUrl: "assets/images/events/padel6.jpg"
            }
        }
    },
    {
        search: { name: "Padel Night Lights" },
        isEvent: true,
        itineraryID: 7,
        category: "Social",
        date: "2024-09-05T20:00:00",
        tickets: [
            {
                category: "Single Player",
                sell: 45,
                currencyCode: "USD",
                description: "Entry for one player",
                imageUrl: "assets/images/events/padel7.jpg",
                stock: 15
            },
            {
                category: "Doubles Team",
                sell: 80,
                currencyCode: "USD",
                description: "Entry for two players",
                imageUrl: "assets/images/events/padel7.jpg",
                stock: 10
            }
        ],
        priceAdvertise: 45,
        currency: "USD",
        supplierName: "Night Padel Club",
        supplier: {
            name: "Night Padel Club",
            place: "Marbella",
            contentShort: "Experience padel under the lights with music and entertainment",
            contentHighlights: "Night Event",
            images: {
                imageUrlBg: "url('assets/images/events/padel7.jpg')",
                rawImageUrl: "assets/images/events/padel7.jpg"
            }
        }
    },
    {
        search: { name: "Padel Charity Cup" },
        isEvent: true,
        itineraryID: 8,
        category: "Charity",
        date: "2024-10-15T09:00:00",
        tickets: [
            {
                category: "Standard Donation",
                sell: 75,
                currencyCode: "USD",
                description: "Includes tournament entry",
                imageUrl: "assets/images/events/padel8.jpg",
                stock: 50
            },
            {
                category: "Premium Donation",
                sell: 150,
                currencyCode: "USD",
                description: "Includes VIP perks",
                imageUrl: "assets/images/events/padel8.jpg",
                stock: 20
            }
        ],
        priceAdvertise: 75,
        currency: "USD",
        supplierName: "Padel for Good",
        supplier: {
            name: "Padel for Good",
            place: "Bilbao",
            contentShort: "All proceeds go to children's sports charities - play for a good cause",
            contentHighlights: "Charity Event",
            images: {
                imageUrlBg: "url('assets/images/events/padel8.jpg')",
                rawImageUrl: "assets/images/events/padel8.jpg"
            }
        }
    },
    {
        search: { name: "Winter Padel League" },
        isEvent: true,
        itineraryID: 9,
        category: "League",
        date: "2024-11-01T18:00:00",
        tickets: [
            {
                category: "Team Registration",
                sell: 400,
                currencyCode: "USD",
                description: "10-week league entry",
                imageUrl: "assets/images/events/padel9.jpg",
                stock: 8
            },
            {
                category: "Individual Player",
                sell: 120,
                currencyCode: "USD",
                description: "We'll place you on a team",
                imageUrl: "assets/images/events/padel9.jpg",
                stock: 15
            }
        ],
        priceAdvertise: 120,
        currency: "USD",
        supplierName: "Winter Padel Association",
        supplier: {
            name: "Winter Padel Association",
            place: "Zaragoza",
            contentShort: "10-week competitive league with indoor courts for winter play",
            contentHighlights: "League Play",
            images: {
                imageUrlBg: "url('assets/images/events/padel9.jpg')",
                rawImageUrl: "assets/images/events/padel9.jpg"
            }
        }
    },
    {
        search: { name: "Padel & Wine Experience" },
        isEvent: true,
        itineraryID: 10,
        category: "Social",
        date: "2024-12-07T16:00:00",
        tickets: [
            {
                category: "Basic Package",
                sell: 85,
                currencyCode: "USD",
                description: "Padel + wine tasting",
                imageUrl: "assets/images/events/padel10.jpg",
                stock: 25
            },
            {
                category: "Premium Package",
                sell: 150,
                currencyCode: "USD",
                description: "Includes gourmet dinner",
                imageUrl: "assets/images/events/padel10.jpg",
                stock: 12
            }
        ],
        priceAdvertise: 85,
        currency: "USD",
        supplierName: "Vino Padel Club",
        supplier: {
            name: "Vino Padel Club",
            place: "Rioja",
            contentShort: "Combine your love of padel with premium wine tasting in our exclusive event",
            contentHighlights: "Gastronomy",
            images: {
                imageUrlBg: "url('assets/images/events/padel10.jpg')",
                rawImageUrl: "assets/images/events/padel10.jpg"
            }
        }
    },
    {
        search: { name: "New Year Padel Marathon" },
        isEvent: true,
        itineraryID: 11,
        category: "Sports",
        date: "2024-12-30T08:00:00",
        tickets: [
            {
                category: "Full Day",
                sell: 90,
                currencyCode: "USD",
                description: "Access all day",
                imageUrl: "assets/images/events/padel11.jpg",
                stock: 40
            },
            {
                category: "Half Day",
                sell: 50,
                currencyCode: "USD",
                description: "Morning or afternoon",
                imageUrl: "assets/images/events/padel11.jpg",
                stock: 30
            }
        ],
        priceAdvertise: 50,
        currency: "USD",
        supplierName: "Padel Marathon Org",
        supplier: {
            name: "Padel Marathon Org",
            place: "Barcelona",
            contentShort: "24-hour padel marathon to celebrate the new year with food and entertainment",
            contentHighlights: "Marathon Event",
            images: {
                imageUrlBg: "url('assets/images/events/padel11.jpg')",
                rawImageUrl: "assets/images/events/padel11.jpg"
            }
        }
    },
    {
        search: { name: "Padel Skills Clinic" },
        isEvent: true,
        itineraryID: 12,
        category: "Training",
        date: "2025-01-15T10:00:00",
        tickets: [
            {
                category: "Beginner",
                sell: 70,
                currencyCode: "USD",
                description: "Fundamentals clinic",
                imageUrl: "assets/images/events/padel12.jpg",
                stock: 15
            },
            {
                category: "Advanced",
                sell: 90,
                currencyCode: "USD",
                description: "High-level techniques",
                imageUrl: "assets/images/events/padel12.jpg",
                stock: 10
            }
        ],
        priceAdvertise: 70,
        currency: "USD",
        supplierName: "Padel Skills Academy",
        supplier: {
            name: "Padel Skills Academy",
            place: "Madrid",
            contentShort: "Specialized clinics focusing on specific skills with professional coaches",
            contentHighlights: "Skill Development",
            images: {
                imageUrlBg: "url('assets/images/events/padel12.jpg')",
                rawImageUrl: "assets/images/events/padel12.jpg"
            }
        }
    },
    {
        search: { name: "Valentine's Padel Couples" },
        isEvent: true,
        itineraryID: 13,
        category: "Social",
        date: "2025-02-14T18:00:00",
        tickets: [
            {
                category: "Couples Entry",
                sell: 120,
                currencyCode: "USD",
                description: "For two players",
                imageUrl: "assets/images/events/padel13.jpg",
                stock: 20
            }
        ],
        priceAdvertise: 120,
        currency: "USD",
        supplierName: "Love Padel Club",
        supplier: {
            name: "Love Padel Club",
            place: "Valencia",
            contentShort: "Special Valentine's tournament for couples with romantic dinner included",
            contentHighlights: "Couples Event",
            images: {
                imageUrlBg: "url('assets/images/events/padel13.jpg')",
                rawImageUrl: "assets/images/events/padel13.jpg"
            }
        }
    },
    {
        search: { name: "Padel Business Networking" },
        isEvent: true,
        itineraryID: 14,
        category: "Corporate",
        date: "2025-03-05T17:00:00",
        tickets: [
            {
                category: "Individual",
                sell: 100,
                currencyCode: "USD",
                description: "Includes networking",
                imageUrl: "assets/images/events/padel14.jpg",
                stock: 30
            },
            {
                category: "Company Package",
                sell: 450,
                currencyCode: "USD",
                description: "5 employees",
                imageUrl: "assets/images/events/padel14.jpg",
                stock: 8
            }
        ],
        priceAdvertise: 100,
        currency: "USD",
        supplierName: "BizPadel Network",
        supplier: {
            name: "BizPadel Network",
            place: "Barcelona",
            contentShort: "Combine business networking with friendly padel competition",
            contentHighlights: "Networking",
            images: {
                imageUrlBg: "url('assets/images/events/padel14.jpg')",
                rawImageUrl: "assets/images/events/padel14.jpg"
            }
        }
    },
    {
        search: { name: "Spring Padel Festival" },
        isEvent: true,
        itineraryID: 15,
        category: "Festival",
        date: "2025-04-10T09:00:00",
        tickets: [
            {
                category: "Day Pass",
                sell: 60,
                currencyCode: "USD",
                description: "Single day entry",
                imageUrl: "assets/images/events/padel15.jpg",
                stock: 100
            },
            {
                category: "Weekend Pass",
                sell: 100,
                currencyCode: "USD",
                description: "Full weekend access",
                imageUrl: "assets/images/events/padel15.jpg",
                stock: 50
            },
            {
                category: "VIP Experience",
                sell: 250,
                currencyCode: "USD",
                description: "All-access pass",
                imageUrl: "assets/images/events/padel15.jpg",
                stock: 15
            }
        ],
        priceAdvertise: 60,
        currency: "USD",
        supplierName: "Padel Fest Org",
        supplier: {
            name: "Padel Fest Org",
            place: "Seville",
            contentShort: "3-day padel festival with competitions, exhibitions, music and food",
            contentHighlights: "Festival",
            images: {
                imageUrlBg: "url('assets/images/events/padel15.jpg')",
                rawImageUrl: "assets/images/events/padel15.jpg"
            }
        }
    }
];

    searchQuery = '';
    filteredPadels: any[] = [];
    originalPadels: any[] = [];
    fallbackImg: string = 'assets/images/cards/No-Image-Placeholder.png?v=1';

    public view: any = {
        visibleEventsCount: 12,
        isClient: true,
        bundles: {
            eventSports: { items: [] }
        },
        filter: {
            events: {
                hasTickets: true
            }
        }
    };

    constructor(
        public _tfmService: TFMService,
        private route: ActivatedRoute,
        private title: Title,
        private metaService: Meta,
        public sanitizer: DomSanitizer,
        private _cd: ChangeDetectorRef,
        private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.view.isClient = this._tfmService.view.isClient;
        this.loadEvents();

        this._tfmService.getSite().then(res => {
            this.view.site = res;
            this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        });

        this.view.currentImageIndex = 0;
        this.view.activeLayer = 1;
        this.view.imageLayer1 = '';
        this.view.imageLayer2 = '';

        this._tfmService.getContentBySection('events').then((res) => {
            this.view.page = res;
            const images = this.view.page?.content?.images;

            if (images && images.length > 0) {
                this.view.imageHrefs = images
                    .map((img: any) => {
                        const viewLink = img._links?.find((link: any) => link.rel === 'view');
                        return viewLink?.href ?? null;
                    })
                    .filter((href: string | null) => href !== null);

                this.view.imageLayer1 = this.view.imageHrefs[0];
            }
        });
    }

    loadEvents() {
        this.originalPadels = this.PADEL_PACKAGES;
        this.filteredPadels = [...this.originalPadels];
        this.view.totalFilteredCount = this.originalPadels.length;
        console.log("It works",this.originalPadels);
        this._cd.detectChanges();
    }

    filterEvents() {
        let filtered = this.originalPadels.filter(event => {
            return this.searchQuery === '' ||
                (event.supplier.name?.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
                (event.supplier.place?.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
                (event.supplier.contentShort?.toLowerCase().includes(this.searchQuery.toLowerCase()));
        });

        this.view.totalFilteredCount = filtered.length;
        this.filteredPadels = filtered.slice(0, this.view.visibleEventsCount);
    }

    loadMore() {
        this.view.visibleEventsCount += 6;
        this.filterEvents();
    }

    enquireEvent(event: any): void {
        const dialogRef = this.dialog.open(EnquirepadelmodalComponent , {
            width: '800px',
            maxHeight: '95vh',
            data: event,
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log('Received booking:', result);
            }
        });
    }
}